const displayFinanceTarget = finance => ({
  order: 'Payment',
  bonus: finance.amount > 0 ? 'Bonus' : 'Fine',
  withdrawal: 'Withdrawal',
}[finance.target] || finance.target);

export default displayFinanceTarget;
